<template>
  <div class="upload-imgs">
    <div class="video-div" v-if="videoObj && Object.keys(videoObj).length > 0" @click="handlePlayVideo">
      <div class="loading" v-if="videoObj && videoObj.isLoading">
        <van-overlay :show="videoObj.isLoading">
          <div class="wrapper-loading" @click.stop>
            <van-loading type="spinner" vertical>上传中...</van-loading>
          </div>
        </van-overlay>
      </div>
      <template v-else>
        <video class="video" ref="videoPre" :src="videoObj && videoObj.url"></video>
        <img src="@/assets/images/course/icon-play-course.png" class="icon-play" alt="">
        <div class="div-cross" @click.stop="handleCilckDel">
          <van-icon name="cross" class="cross" />
        </div>
      </template>
    </div>
    <van-uploader v-else v-model="fileList" :disabled="isUpload" :max-count="maxCount" :accept="fileType"
      :before-delete="handleDel" :beforeRead="beforeRead" />
    <div class="dialog-div" v-show="showOverlay">
      <div class="dialog-bg" @click.stop="handleClose"></div>
      <video :src="videoObj && videoObj.url" ref="videos" preload="auto" controls playsinline webkit-playsinline
        class="overlay-video"></video>
    </div>
  </div>
</template>
<script>
import { uploadPathFile, filesInfo } from '@/api/zone'
import { allVideo } from '../data'
export default {
  props: {
    uploadType: '',
  },
  data () {
    return {
      videoObj: {},
      fileList: [],
      uploadList: [],
      isUpload: false,
      maxCount: 9,
      fileType: 'image/*,video/*',
      fileIds: [],
      maxSize: 100 * 1024 * 1024,
      showOverlay: false
    }
  },
  methods: {
    handleEmit() {
      this.$emit('uploadSucc', {
        uploadList: this.uploadList,
        videoObj: this.videoObj
      })
    },
    handleCilckDel () {
      this.isUpload = false
      this.videoObj = Object.assign({})
      this.uploadList = []
      this.$parent.fileIds = []
      if (this.uploadList.length === 0) {
        this.fileType = 'image/*,video/*'
      }
      this.handleEmit()
    },
    beforeRead (file) {
      if (file.size > this.maxSize) {
        this.onOversize()
        return false
      }
      if (file.type.indexOf('video') > -1) {
        this.videoObj = { isLoading: true }
        if (this.uploadList.length > 0) {
          this.$toast('上传图片中间不能穿插视频！')
          return false
        }
        this.handleUpload(file)
        return false
      }
      this.fileType = 'image/*'
      this.handleUpload(file)
      return true
    },
    onOversize () {
      this.$toast(`文件大小不能超过 ${this.maxSize / 1024 / 1024}M`)
      this.videoObj = {}
    },
    handlePlayVideo () {
      this.showOverlay = true
      this.$refs.videos.play()
    },
    handleClose () {
      this.$refs.videos.pause()
      this.showOverlay = false
    },
    handleUpload (respon) {
      // type: 1发帖2投票3直播预估4代办任务(作业)
      let formData = new FormData()
      formData.append('type', '1')
      formData.append('number', this.fileList.length + 1 + '')
      formData.append('mainId', '')
      formData.append('file', respon)
      uploadPathFile(formData).then(res => {
        if (respon.type.indexOf('video') > -1) {
          this.isUpload = true
          this.videoObj.isLoading = false
          this.videoObj = Object.assign(this.videoObj, res.data)
        }
        // this.fileIds.push(res.data.id)
        this.uploadList.push(res.data)
        if (this.$refs.videoPre) {
          setTimeout(() => {
            this.$refs.videoPre.play()
            this.$refs.videoPre.pause()
          })
        }
        this.handleEmit()
      }).catch((err) => {
        if (`${err.code}` !== '0') {
          this.$toast('上传失败')
          this.videoObj = {}
        }
      })
    },
    handleFun (adminFileMainId) {
      if (adminFileMainId) {
        filesInfo({ mainId: adminFileMainId }).then(res => {
          this.fileList = []
          this.uploadList = res.data
          if (res.data.length === 1 && allVideo.indexOf((res.data[0].format).toLocaleLowerCase()) > -1) {
            this.videoObj = res.data[0]
          } else {
            this.fileList = res.data
          }
          if (res.data.length > 0) {
            this.fileType = 'image/*'
          }
          this.handleEmit()
        })
      }
    },
    handleDel (e) {
      this.$parent.fileIds = []
      if (e.filename) {
        this.uploadList = this.uploadList.filter(res => `${res.filename}` !== `${e.filename}`)
      } else {
        this.uploadList = this.uploadList.filter(res => `${res.title}.${res.format}` !== `${e.file.name}`)
      }
      if (this.uploadList.length === 0) {
        this.fileType = 'image/*,video/*'
      }
      this.handleEmit()
      return true
    }
  }
}
</script>
<style scoped lang="less">
.dialog-div {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  .dialog-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 999;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .7);
  }
  .overlay-video {
    width: 100%;
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 9998;
  }
}
.upload-imgs {
  display: flex;
  flex-wrap: wrap;
  padding: 16px 14px;
  box-sizing: border-box;

  .video-div {
    width: 109px;
    height: 109px;
    margin-right: 10px;
    position: relative;
    background-color: rgba(247 248 250, .5);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    .div-cross {
      position: absolute;
      top: 0;
      right: 0;
      width: 14px;
      height: 14px;
      background-color: rgba(0, 0, 0, .7);
      border-radius: 0 0 0 12px;

      /deep/ .cross {
        font-size: 10px;
        color: #fff;
        top: -4px;
        right: -3px;
      }
    }

    .video {
      width: 100%;
      height: 100%;
    }

    .icon-play {
      position: absolute;
      width: 36px;
      height: 36px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  /deep/ .van-uploader__wrapper {
    .van-uploader__preview,
    .van-image,
    .van-uploader__upload {
      width: 109px;
      height: 109px;
      margin-right: 10px;

      &:nth-child(3n) {
        margin-right: 0;
      }
    }

    .van-uploader__upload-icon {
      font-size: 36px;
    }
  }
}
.wrapper-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/compontents/uploaderVideo.vue